import type { TFunction } from 'i18next';

export interface IArchiveToggleCopy {
  label: string;
  helpText: string;
  modalTitle: string;
  modalIntro: string;
  modalBullets: string[];
  confirmButtonText: string;
  successMessage: string;
  errorMessage: string;
}

/**
 * Centralized, single-source copy for the Archive/Restore project control.
 */
export function getArchiveToggleCopy(isHidden: boolean, t: TFunction): IArchiveToggleCopy {
  return {
    label: isHidden ? t('Restore project') : t('Archive project'),
    helpText: isHidden
      ? t(
          'This project has been archived from your projects list. You can restore it to see it again.',
        )
      : t(
          'If you archive this project you will no longer see it in your projects list. The associated campaigns will keep running and the billing configurations will remain unchanged. You can restore it at any time.',
        ),
    modalTitle: t('Archive this project?'),
    modalIntro: t('Archiving this project will:'),
    modalBullets: [
      t('Hide it from your projects list'),
      t('Keep its campaigns, data, and billing unchanged'),
      t('Let you restore it anytime'),
    ],
    confirmButtonText: t('Archive'),
    successMessage: isHidden ? t('Project archived.') : t('Project restored.'),
    errorMessage: t('Something went wrong while updating the project.'),
  };
}
